import * as React from "react";
import { StyledTable as StyledTableComponent } from "../../../styles/DeviceConnet";
import { DisconnectOutlined } from "@ant-design/icons";
import { IDeviceConnection } from "../../../api_types";

interface IProps {
  unlink: IDeviceConnection[];
  loading: boolean;
}
const StyledTable = ({ unlink, loading }: IProps) => {
  const unlinkColumns = [
    {
      title: "序号",
      dataIndex: "rank",
      width: 100,
    },
    {
      title: "踏板别名",
      dataIndex: "DeviceName",
      width: 150,
    },
    {
      title: "连线状态",
      width: 120,
      render: () => <div>无连线记录</div>,
    },
    {
      title: "踏板ID",
      dataIndex: "DeviceUUID",
      width: 150,
    },
  ];
  return (
    <StyledTableComponent
      className="bordered-table-blue"
      columns={unlinkColumns}
      dataSource={unlink}
      pagination={false}
      scroll={{ x: "max-content" }}
      size={"small"}
      rowKey="DeviceUUID"
      loading={loading}
      sticky
      title={() => (
        <div className="unlinkDevice">
          <DisconnectOutlined /> 无连线记录踏板
        </div>
      )}
      bordered
    />
  );
};

export default StyledTable;
